// extracted by mini-css-extract-plugin
module.exports = {"referralWrapper":"styles-module__referralWrapper___2CWaM","referralName":"styles-module__referralName___3Exo5"};